module.exports = __webpack_public_path__ + "img/tube.043a23d0.png";